import { Text } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  CONNECTOR,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  TagItem,
  TagsListTruncate,
} from 'ui'
import { IconComponent } from '../../../../../../ItemsView/IconComponent'
import { SCOPE_OPTIONS } from '../../../../../../ItemsView/typing'
import { ScopeRuleProps } from '../ItemsView'
import { messages } from '../messages'
import { ITEMS_TRUNCATE_LINES } from '../constants'

export function CategoriesRule(props: ScopeRuleProps) {
  const { config, onEdit, onRemove } = props
  const { items, operator } = config

  const { $t } = useIntl()

  return (
    <Rule onClick={onEdit} connector={CONNECTOR.AND}>
      <RuleIcon>
        <IconComponent icon={SCOPE_OPTIONS.CATEGORIES} />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages[SCOPE_OPTIONS.CATEGORIES]}
          values={{
            operator: operator,
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <TagsListTruncate
          content={items.map(({ name, id }) => $t(messages.item, { name, id }))}
          lines={ITEMS_TRUNCATE_LINES}
        >
          {items.map((item, index) => (
            <TagsListTruncate.Atom key={index}>
              <TagItem item={item} key={item.id} />
            </TagsListTruncate.Atom>
          ))}
        </TagsListTruncate>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions
          onEdit={onEdit}
          onRemove={() => onRemove(SCOPE_OPTIONS.CATEGORIES)}
        />
      </RuleActions>
    </Rule>
  )
}
